import React from 'react';
import {
  ActionList,
  ActionListItem,
  Dropdown,
  DropdownOverlay,
  FilterChipSelectInput,
} from '@razorpay/blade/components';

import { EnumFilterChipProps } from './types';
import { getEnumOptions } from './utils';

export const EnumFilterChip = ({
  definition,
  value,
  isDisabled,
  onChange,
  onClearButtonClick,
}: EnumFilterChipProps) => {
  return (
    <Dropdown selectionType="multiple">
      <FilterChipSelectInput
        accessibilityLabel={`${definition.label} filter`}
        name={definition.fieldKey}
        label={definition.label}
        value={value}
        isDisabled={isDisabled}
        onChange={({ values }) => onChange(values)}
        onClearButtonClick={onClearButtonClick}
      />
      <DropdownOverlay minWidth="240px">
        <ActionList>
          {getEnumOptions(definition).map((option) => (
            <ActionListItem key={option.value} title={option.title} value={option.value} />
          ))}
        </ActionList>
      </DropdownOverlay>
    </Dropdown>
  );
};
